import { Component, inject } from '@angular/core';
import { Entity } from '@app/core/model/entities/entity';
import { DocumentsService } from '@app/features/main/views/organization-documents/documents.service';
import {
  ServerSideIndicatorStatusPanelComponent
} from '@app/shared/components/indicator-status-panel/server-side-indicator-status-panel/server-side-indicator-status-panel.component';
import { SelectParams } from '@app/shared/grid/datasource-utils';
import { IStatusPanelParams } from 'ag-grid-community';
import { merge, Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';

@Component({
  selector: 'documents-indicator-status-panel',
  templateUrl: '../indicator-status-panel.component.html',
  styleUrls: ['../indicator-status-panel.component.scss'],
  standalone: false
})
export class DocumentsIndicatorStatusPanelComponent extends ServerSideIndicatorStatusPanelComponent {
  private documentsService = inject(DocumentsService);

  /**
   * Set gridApi and add listen for row updates.
   */
  public agInit(params: IStatusPanelParams<Entity>): void {
    super.agInit(params);

    merge(
      this.documentsService.documentsAdded$,
      this.documentsService.documentUpdated$,
      this.documentsService.documentsDeleted$
    )
      .subscribe(() => this.updateIndicatorsValues());
  }

  /**
   * Get aggregation result.
   * @param selectParams The parameters for the query. These include filtering, and aggregating.
   * @return Observable<Entity> Result of the aggregation query.
   */
  protected getAggregationResult(selectParams: SelectParams): Observable<Entity> {
    return this.documentsService.loadDocumentsPage(selectParams)
      .pipe(first(), map(documents => documents.first()));
  }
}
